import "./AIMessage.css";
import { AgentChatResponseToolbar } from "./AgentChatResponseToolbar";
import { useMessageThreadInfo } from "../../hooks/useMessageThreadInfo";
import { AIResponseMessage } from "./types";
import { useSelector } from "react-redux";
import { useState, useRef, useEffect } from "react";

import { selectLinkRecords } from "../../redux/features/appData/appDataSlice";
import { ThreadInfo } from "./ThreadInfo";
import { getStoreLinkRecord } from "winslow-core";
import { LinkRecordActivity } from "../shares/LinkRecordActivity";
import { DeterminedPersonas } from "./DeterminedPersonas";
import { selectPersonas } from "../../redux/features/agent/agentSlice";
import { showdownConverter } from "winslow-core";
import { FeedbackRating } from "./FeedbackRating";

type AIMessageProps = {
  message: AIResponseMessage;
  onExpand: (message: AIResponseMessage) => void;
};

export const AIMessage = ({ message, onExpand }: AIMessageProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [needsExpansion, setNeedsExpansion] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  const contextInfo = useMessageThreadInfo(message.thread);
  const personas = useSelector(selectPersonas);
  const content = message.message.kwargs.content;
  const linkRecords = useSelector(selectLinkRecords);

  useEffect(() => {
    if (contentRef.current) {
      const contentHeight = contentRef.current.scrollHeight;
      const needsToExpand = contentHeight > 250;
      setNeedsExpansion(needsToExpand);
    }
  }, [content]);

  const handleExpand = () => {
    if (needsExpansion) {
      setIsExpanded((prev) => !prev);
    }
    onExpand(message);
  };

  const handlePreviewClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onExpand(message);
  };

  // const getContentClass = () => {
  //   if (!needsExpansion) return "";
  //   return isExpanded ? "expanded" : "collapsed";
  // };

  return (
    <>
      <div className="agent-chat-history-prompt-response">
        {message.personaIds && (
          <DeterminedPersonas personaIds={message.personaIds} />
        )}
        <div
          className={`agent-chat-history-prompt-response-object `}
          onClick={handleExpand}>
          <div className="agent-chat-history-general">
            <div
              className="agent-chat-q-and-a-preview"
              onClick={handlePreviewClick}>
              {message.sources && message.sources.length > 0 && (
                <div className="agent-chat-q-and-a-preview-sources">
                  {/* limit to top 5 sources */}
                  {message.sources.slice(0, 5).map((linkRecordId) => {
                    const linkRecord = getStoreLinkRecord(
                      linkRecordId,
                      linkRecords ?? []
                    );
                    if (!linkRecord) return null;

                    return (
                      <LinkRecordActivity
                        key={linkRecordId}
                        linkRecord={linkRecord}
                        minimum={true}
                        showDrag={false}
                        clickIsOpen={true}
                      />
                    );
                  })}
                </div>
              )}
              <div
                ref={contentRef}
                className="agent-chat-q-and-a-preview-content"
                dangerouslySetInnerHTML={{
                  __html: showdownConverter.makeHtml(content),
                }}>
                {/* Content is injected via dangerouslySetInnerHTML */}
              </div>
            </div>
          </div>
        </div>

        <div className="agent-chat-history-item-toolbar">
          <AgentChatResponseToolbar
            key={`toolbar-${message.id}`}
            message={message}
          />
          {contextInfo && (
            //the persona that is selected for the thread
            <ThreadInfo avatar={contextInfo.avatar} label={contextInfo.label} />
          )}
        </div>
      </div>
    </>
  );
};
